import React from 'react';
import Axios from 'axios';
import { Link } from 'react-router-dom';
import moment from 'moment';

import * as myConstClass from './shared/constants/constants';

class Stats extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			seasonsData: {
				activeSeasonsGroups: [],
				activeTournaments: [],
				allLeagues: [],
				allTournaments: []
			},

			showActiveSeasonsGroupItems: [],
			showAllSeasonItems: []
		};

		this.createRowsActSeasonsGroups = this.createRowsActSeasonsGroups.bind(this);
		this.createRowsActTn = this.createRowsActTn.bind(this);
		this.createRowsAllLeaguesTournaments = this.createRowsAllLeaguesTournaments.bind(this);
		this.createRowsAllSeasons = this.createRowsAllSeasons.bind(this);

		this.onActiveSeasonsGroupsItemClick = this.onActiveSeasonsGroupsItemClick.bind(this);
		this.onAllSeasonItemClick = this.onAllSeasonItemClick.bind(this);
	}

	componentDidMount() {
		//console.log('Stats: componentDidMount');
		this.loadSeasonsFromApi();
	}

	loadSeasonsFromApi() {
		var _this = this;
		Axios.get('/api/seasons/menulist').then(function(response) {

			var seasonsData = response.data; 
			//console.log('seasonsData');
			//console.log(seasonsData);

			_this.setState({
				seasonsData: seasonsData,
			});
		});
	}

	render() {
		var _this = this;
		// const isMobile = window.innerWidth < 768;
		// console.log('isMobile:', isMobile);

		return (
			<div className="animated fadeIn">
				{/* understanding the grid system ... */}
        <div className="row">
        <div className="col-md-12 col-xs-12">
          <h4>Statistiques</h4>
          <p>LA PUISSANCE DES STATS</p>
          <p>Choisissez votre ligue et visionnez vos classements par équipes ou par joueurs</p>
        </div>
        </div>

        <div className="row">
        <div className="col-md-6 col-xs-12">

        	{/* Here if media width < 768*/}
	        <div className="row only-on-mobile">
  	      <div className="col-md-12 col-xs-12">
        		{this.dispPromoMessage()}
        		<br/>
	        </div>
  	      </div>


					<h5>Ligues actives</h5>
					{(this.state.seasonsData.activeSeasonsGroups.length > 0)
						? <ul> {this.state.seasonsData.activeSeasonsGroups.map(this.createRowsActSeasonsGroups)} </ul> 
						: <span> Aucune <br/><br/></span>
					}

					<h5>Tournois actifs</h5>
					{(this.state.seasonsData.activeTournaments.length > 0)
						? <ul> {this.state.seasonsData.activeTournaments.map(this.createRowsActTn)} </ul> 
						: <span> Aucun <br/><br/></span>
					}

        </div>

				<div className="col-md-6 col-xs-12">

        	{/* Here if media width > 768*/}
	        <div className="row not-on-mobile">
  	      <div className="col-md-12 col-xs-12">
        		{this.dispPromoMessage()}
        		<br/><br/>
	        </div>
  	      </div>
	
	        <div className="row">
  	      <div className="col-md-6">
						{this.dispQvnea()}
	        </div>
	
  	      <div className="col-md-6">
						{this.dispSpecialQcInvLeaders2023()}
						{this.dispSpecialQcOpenLeaders2020()}
						{this.dispSpecialQcOpenLeaders2019()}
						{this.dispSpecialQcOpenLeaders2018()}
	        </div>
  	      </div>

         <br/>
				</div>
				</div>
				<hr/>

        <div className="row">
        <div className="col-12">
          <h4>Historique des ligues et tournois</h4>
        </div>

        <div className="col-md-6 col-xs-12">
					<h5>Ligues</h5>
					<ul> {this.state.seasonsData.allLeagues.map(this.createRowsAllLeaguesTournaments)} </ul>
        </div>

        <div className="col-md-6 col-xs-12">
					<h5>Tournois</h5>
					<ul> {this.state.seasonsData.allTournaments.map(this.createRowsAllLeaguesTournaments)} </ul>
					<br/>
        </div>

        </div>
      </div>
		);
	}

	dispPromoMessage() {
		return (
			<div>
				<a href="/tableau-de-bord">
					<img className="img-fluid" src="/img/regulier-aut-2019.png" alt="tableau-de-bord" width="500"/>
   			</a>
   			<br/>
			</div>
		);
	}

	dispQvnea() {
		return (
			<div>
				<a href="http://qvnea.com" target="_blank">
				<img className="img-fluid" src="/img/qvnea_logo_01b.png" alt="qvnea" width="300"/><br/><br/>	
				</a>
			</div>
		);
	}

	dispSpecialQcOpenLeaders2018() {
		return (
			<div>
				<Link to='/special/QuebecOpenLeaderboards2018/'>
				<img className="img-fluid" src="/img/qo2018-title01a.png" alt="leaders" width="250"/><br/><br/>	
				</Link>
			</div>
		);
	}

	dispSpecialQcOpenLeaders2019() {
		return (
			<div>
				<Link to='/special/QuebecOpenLeaderboards2019/'>
				<img className="img-fluid" src="/img/qo2019-title01a.png" alt="leaders" width="250"/><br/><br/>	
				</Link>
			</div>
		);
	}

	dispSpecialQcOpenLeaders2020() {
		return (
			<div>
				<Link to='/special/QuebecOpenLeaderboards2020/'>
				<img className="img-fluid" src="/img/qo2020-title01a.png" alt="leaders" width="250"/><br/><br/>	
				</Link>
			</div>
		)
	}

	dispSpecialQcInvLeaders2023() {
		return (
			<div>
				<Link to='/special/QuebecInvLeaderboards2023/'>
				<img className="img-fluid" src="/img/qi2023-title01a.png" alt="leaders" width="250"/><br/><br/>	
				</Link>
			</div>
		)
	}

	createRowsActTn(season) {
		return (
			<li key={season._id} >
				<Link to={'/standings/' + season._id}>{season.name}</Link>
			</li>
		);
	}

	createRowsActSeasonsGroups(seasonGroup, idx) {

		if (seasonGroup.type === "group") {
			// group
			return (
				<li key={'seasonGroup' + idx}>
				<span className="stateloListItemPointer" onClick={this.onActiveSeasonsGroupsItemClick.bind(this, idx)}> {seasonGroup.name} 
					{this.state.showActiveSeasonsGroupItems[idx] ?
						<ul> {seasonGroup.seasons.map(this.createRowsAllSeasons)} </ul> : null}
				</span>
				</li>
			);

		} else {
			// season
			return (
				<li key={seasonGroup.seasonId} >
					<Link to={'/standings/' + seasonGroup.seasonId}>{seasonGroup.name}</Link>
				</li>
			);
		}
	}

	createRowsAllLeaguesTournaments(league, idx) {
		return (
			<li key={league.leagueId}>
			<span className="stateloListItemPointer" onClick={this.onAllSeasonItemClick.bind(this, idx)}> {league.leagueName} 
				{this.state.showAllSeasonItems[idx] ?
					<ul> {league.seasons.map(this.createRowsAllSeasons)} </ul> : null}
			</span>
			</li>
		);
	}

	createRowsAllSeasons(season) {
		return (
			<li key={season._id} >
				<Link to={"/standings/" + season._id}>{season.name}</Link>
			</li>
		);
	}

	onActiveSeasonsGroupsItemClick(index) {
   	let showActiveSeasonsGroupItems = this.state.showActiveSeasonsGroupItems.slice();
   	let prevShowActiveSeasonsGroupItem = showActiveSeasonsGroupItems[index];
   	showActiveSeasonsGroupItems.forEach(function (item, idx) {showActiveSeasonsGroupItems[idx] = false});
   	showActiveSeasonsGroupItems[index] = !prevShowActiveSeasonsGroupItem;
   	this.setState({showActiveSeasonsGroupItems});
	}

	onAllSeasonItemClick(index) {
   	let showAllSeasonItems = this.state.showAllSeasonItems.slice();
   	let prevShowAllSeasonItem = showAllSeasonItems[index];
   	showAllSeasonItems.forEach(function (item, idx) {showAllSeasonItems[idx] = false});
   	showAllSeasonItems[index] = !prevShowAllSeasonItem;
   	this.setState({showAllSeasonItems});
	}

}

export default Stats;